import React from "react";
import { intervalToDuration, formatDuration, parseISO, format } from "date-fns";
import { Clock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { de, es, enUS } from "date-fns/locale";

type TimeFormatterProps = {
  seconds: number;
  startedSession: string;
  endedSession: string;
};

const TimeFormatter: React.FC<TimeFormatterProps> = ({
  seconds,
  startedSession,
  endedSession,
}) => {
  const { t } = useTranslation();
  const { lang } = useParams<{ lang: string }>();
  const getLocale = () => {
    switch (lang) {
      case "de":
        return de;
      case "es":
        return es;
      default:
        return enUS;
    }
  };
  const duration = intervalToDuration({ start: 0, end: seconds * 1000 });
  const formattedDuration = formatDuration(duration, {
    locale: getLocale(),
    delimiter: ", ",
    format: ["hours", "minutes", "seconds"],
  });
  const parsedStartedDate = parseISO(startedSession);

  const formattedStartingDate = format(parsedStartedDate, "yyyy/MM/dd HH:mm");
  const parsedEndingDate = parseISO(endedSession);
  const formattedEndingDate = format(parsedEndingDate, "yyyy/MM/dd HH:mm");
  return (
    <div className="flex flex-col justify-start items-start gap-2 border-t border-b pb-1 w-full">
      <div className="flex justify-between items-center w-full font-semibold py-4 gap-1">
        <div className="flex gap-2 items-center">
          <Clock size={"24px"} className="text-black" />
          <p>{t("transaction.duration")}</p>
        </div>
        <p>{formattedDuration}</p>
      </div>
      <div className="flex px-2 justify-between items-center w-full font-semibold gap-2">
        <div className="flex gap-2 items-center">
          <p>{t("common.start")}</p>
        </div>
        <p>{formattedStartingDate}</p>
      </div>
      <div className="flex px-2 justify-between items-center w-full font-semibold gap-2">
        <div className="flex gap-2 items-center">
          <p>{t("common.end")}</p>
        </div>
        <p>{formattedEndingDate}</p>
      </div>
    </div>
  );
};

export default TimeFormatter;
